export default {
  colors: {
    primary: '#503296',
    secondary: '#7b8EE1',
    tertiary: '#38C6F4',
    dark: '#3C414B',
    light: '#FFFFFF',
    warning: '#FF7928',
    error: '#FF3068',
    success: '#2DE6BC',
    background1: '#2D005A',
    background2: '#EBF0F3',
    background3: '#F6F8F9',
    background4: '#F6F8F9',
    background5: '#F6F8F9',
    background6: '#F6F8F9',
  },
  gradients: {
    primary: 'linear-gradient(to right, #503296, #2D005A)',
    secondary: 'linear-gradient(to right, #503296, #2D005A)',
    tertiary: 'linear-gradient(to right, #503296, #2D005A)',
  },
  alternateBgColor: true,
  fonts: {
    headings: {
      family: 'objektiv-mk2-light, Arial',
      sm: {
        size: [24, 40],
        lineHeight: [28, 48],
        weight: 300,
      },
      md: {
        size: [28, 48],
        lineHeight: [32, 56],
        weight: 300,
      },
      lg: {
        size: [32, 52],
        lineHeight: [38, 60],
        weight: 300,
      },
    },
    subheadings: {
      family: 'objektiv-mk2-medium, Arial',
      sm: {
        size: [18, 20],
        lineHeight: [24, 28],
        weight: 500,
      },
      md: {
        size: [20, 24],
        lineHeight: [24, 32],
        weight: 500,
      },
      lg: {
        size: [22, 28],
        lineHeight: [24, 36],
        weight: 500,
      },
    },
    body: {
      family: 'proxima-nova, Arial',
      legal: {
        size: 12,
        lineHeight: 16,
      },
    },
  },
  backgroundColors: {
    light: {
      textColor: '#3C414B',
    },
  },
  components: {
    PackageCard: {
      color: '#1D2329',
      backgroundColor: '#F6F8F9',
      radius: '24px',
      shadow: 0,
      stroke: {
        width: '1px',
        style: 'solid', // CSS value
        color: '#503296',
      },
      label: {
        inside: true,
        backgroundColor: '#38C6F4',
        radius: '32px',
      },
    },
    Button: {
      rounded: 'max',
      variants: {
        primary: {
          color: 'white',
          hoverColor: 'white',
          activeColor: 'white',
        },
        light: {
          textColor: 'black',
        },
      },
    },
    ListItem: {
      icon: 'Done',
    },
    Price: {
      color: '#503296',
      dollarSign: {
        size: '24px',
        position: 'top', // top, bottom (default), center
        weight: 'bold', // normal, bold
        offsetY: '5px',
        offsetX: '2px',
      },
      duration: {
        size: '20px',
        position: 'top', // top, bottom (default), center
        weight: 'normal', // normal, bold
        offsetY: '5px',
        offsetX: '-2px',
      },
    },
  },
  shadow: '0 0.3rem 1rem 0 rgba(0, 0, 0, 0.1)',
  radius: '4px',
}
